import React from "react";

const DeleteConfirmModal = ({
  id = "confirm-modal",
  title = "Confirmation",
  message = "Are you sure you want to delete this record?",
  deleteAsync,
  setDeleteId
}) => {
  return (
    <div className="modal fade" id={id} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>

            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onclick={() => setDeleteId(0)}
            />
          </div>

          <div className="modal-body">
            <p className="mb-0">{message}</p>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onclick={() => setDeleteId(0)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={deleteAsync}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;